"use client";
import { useState } from "react";
const faqs = [
    {
        question: " What neurological conditions are treated at HDNA Aarogyam Hospital?",
        answer: "DNA Aarogyam Hospital treats a wide range of neurological conditions including stroke, epilepsy, migraine, Parkinson’s disease, dementia, neuropathy, spinal cord injuries, nerve compression, brain tumors, and neuromuscular disorders.",
    },
     {
        question: "Does HDNA Aarogyam Hospital provide emergency stroke care?",
        answer: "Yes, the hospital has a dedicated Emergency Stroke Management Unit with 24x7 Neuro ICU support to provide rapid treatment within the golden hour, improving recovery outcomes.",
    },
    {
        question: "What diagnostic tests are available for neurological disorders?",
        answer: "The Neurology Department is equipped with advanced diagnostics such as EEG, EMG, MRI, CT Scan, and Nerve Conduction Studies for accurate diagnosis of brain and nerve conditions.",
    },
    {
        question: "When should I consult a neurologist?",
        answer: "You should consult a neurologist if you experience persistent headaches, dizziness, seizures, memory loss, limb weakness, numbness, difficulty in speech, or walking problems.",
    },
    {
        question: "Is neuro rehabilitation available after stroke or brain surgery?",
        answer: "Yes, HDNA Aarogyam Hospital offers comprehensive Neuro Rehabilitation Programs, including physiotherapy, speech therapy, occupational therapy, and cognitive training for post-stroke and post-surgery recovery.",
    },
     {
        question: "Are both neurologists and neurosurgeons available at the hospital?",
        answer: "Yes, the hospital has a team of experienced neurologists and neurosurgeons who work together to provide complete medical and surgical care for neurological disorders.",
    },
    {
        question: "How is epilepsy and seizure disorder managed at HDNA Aarogyam Hospital?",
        answer: "Epilepsy is managed through accurate diagnosis using EEG, personalized medication plans, continuous monitoring, and long-term follow-up under expert neurologists.",
    },
    {
        question: "Does the hospital treat spine and nerve-related problems?",
        answer: "Yes, the Neurology Department specializes in treating spinal cord injuries, nerve compression, neuropathy, and chronic nerve pain using a multidisciplinary treatment approach.",
    },
    {
        question: "What support services are provided for long-term neurological recovery?",
        answer: "Patients receive holistic support including rehabilitation therapy, psychological counseling, lifestyle guidance, diet counseling for brain health, and regular follow-ups.",
    },
    {
        question: "Why should I choose HDNA Aarogyam Hospital for neurology care in Bihar?",
        answer: "HDNA Aarogyam Hospital combines experienced neuro specialists, advanced diagnostics, 24x7 emergency care, and compassionate patient support, making it a trusted center for neurology care across Bihar.",
    }
];
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
